// Predefined Google Technologies
export const GOOGLE_TECHNOLOGIES = [
  "Google Cloud Platform (GCP)",
  "Firebase",
  "TensorFlow",
  "Google Cloud AI/ML",
  "Google Cloud Storage",
  "Google Cloud Functions",
  "Google Cloud Run",
  "Google Kubernetes Engine (GKE)",
  "Google Cloud BigQuery",
  "Google Cloud Pub/Sub",
  "Google Cloud Vision API",
  "Google Cloud Natural Language API",
  "Google Cloud Translation API",
  "Google Cloud Speech-to-Text",
  "Google Cloud Text-to-Speech",
  "Dialogflow",
  "Google Maps API",
  "YouTube Data API",
  "Google Analytics",
  "Google Workspace APIs",
  "Angular",
  "Flutter",
  "Dart",
];

